import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEye, 
  faCheck, 
  faClock, 
  faTimes,
  faExclamationTriangle,
  faExclamationCircle,
  faInfoCircle,
  faCheckCircle,
  faCalendar
} from '@fortawesome/free-solid-svg-icons';
import { Button } from '@themesberg/react-bootstrap';
import { getNotificationConfig, formatNotificationTime, getAvailableActions } from '../utils/notificationUtils';
import { NOTIFICATION_ACTIONS } from '../constants/notificationTypes';

// Map string icons to FontAwesome icons
const getIconComponent = (iconName) => {
  const iconMap = {
    'exclamation-triangle': faExclamationTriangle,
    'exclamation-circle': faExclamationCircle,
    'info-circle': faInfoCircle,
    'check-circle': faCheckCircle,
    'eye': faEye,
    'check': faCheck,
    'clock': faClock,
    'calendar': faCalendar,
    'times': faTimes
  };
  return iconMap[iconName] || faInfoCircle;
};

const NotificationToast = ({ 
  notification, 
  onAction, 
  onDismiss, 
  isVisible = true 
}) => {
  const config = getNotificationConfig(notification);
  const availableActions = getAvailableActions(notification);
  
  const handleAction = (actionType) => {
    onAction(actionType, notification);
    if (actionType === 'DISMISS') {
      onDismiss();
    }
  };

  return (
    <div
      className={`${
        isVisible ? "animate-enter" : "animate-leave"
      } notification-toast d-flex bg-white shadow-lg rounded pointer-events-auto ring-1 ring-black ring-opacity-5`}
      style={{
        width: '400px',
        maxWidth: '90vw',
        borderLeft: `4px solid ${config.color}`,
        backgroundColor: config.backgroundColor,
        borderColor: config.borderColor
      }}
    >
      <div className="d-flex flex-1 p-3">
        <div className="d-flex align-items-start">
          {/* Notification Icon */}
          <div 
            className="flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{ 
              width: 40, 
              height: 40, 
              backgroundColor: config.color,
              color: 'white'
            }}
          >
            <FontAwesomeIcon 
              icon={getIconComponent(config.icon)} 
              size="sm"
            />
          </div>
          
          {/* Notification Content */}
          <div className="flex-1">
            <div className="d-flex justify-content-between align-items-start mb-1">
              <h6 className="mb-0 fw-bold" style={{ color: config.color }}>
                {notification.notification_type}
                {notification.isGroup && (
                  <span className="badge bg-secondary ms-2 small">
                    {notification.count}
                  </span>
                )}
              </h6>
              <small className="text-muted">
                {formatNotificationTime(notification.created_at)}
              </small>
            </div>
            
            <p className="mb-2 small text-dark">
              {notification.message}
            </p>
            
            {/* Action Buttons */}
            <div className="d-flex gap-2 flex-wrap">
              {availableActions.map(actionType => {
                const action = NOTIFICATION_ACTIONS[actionType];
                return (
                  <Button
                    key={actionType}
                    variant={action.variant}
                    size={action.size}
                    onClick={() => handleAction(actionType)}
                    className="d-flex align-items-center"
                  >
                    <FontAwesomeIcon 
                      icon={getIconComponent(action.icon)} 
                      className="me-1" 
                      size="xs"
                    />
                    {action.label}
                  </Button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      
      {/* Close Button */}
      <div className="d-flex align-items-start p-2">
        <Button
          variant="link"
          size="sm"
          onClick={onDismiss}
          className="text-muted p-1"
          style={{ lineHeight: 1 }}
        >
          <FontAwesomeIcon icon={faTimes} size="sm" />
        </Button>
      </div>
    </div>
  );
};

export default NotificationToast;